import type { EventDataInterface } from '@nextgen-web-framework/core';
import { AdvanceShareCodeResponse } from '@commerce-webcomponents/sdk';
// Will revisit later once masterdata typesafing capability is enabled - AccountType
import { AccountType } from '../../../components/ShareModal/types/propTypes';
export interface ShareEventDataInterface extends EventDataInterface {
  product_brand?: string[];
  share_channel: string;
  product_id?: string[];
  product_name?: string[];
  product_pointValue?: string[];
  product_unitPrice?: string[];
}

export enum ShareEventsEnum {
  PDP = 'pdp',
  SHARE = 'share',
  MYLIST = 'mylist',
  POSTPURCHASE = 'postpurchase',
}

export enum ShareEventsVersionsEnum {
  '1.0.0' = '1.0.0',
}

export type SharePublishEventType = {
  payload: ShareEventDataInterface;
  event: string;
  sync?: boolean;
};

export interface CreateSharecodeParams {
  linkProps?: AdvanceShareCodeResponse;
  sharingChannel?: string;
  regType?: AccountType;
}
